import { styled } from '@linaria/react';
import { StyledInput, Button } from '@vidbaseapp/styleguide';
import { StyledLandingSection } from './LandingSection';
export const StyledNewsletter = /*#__PURE__*/styled("div")({
  name: "StyledNewsletter",
  class: "s1wh0uhe"
});
export const LandingSignup = () => {
  return <StyledLandingSection id="newsletter" className="signup-cta">
			<div className="content">
				<div className="headline">
					<h2>Want News &amp; Updates?</h2>
					<p>Sign up for our newsletter.</p>
				</div>
				<StyledNewsletter className="newsletter-form">
					<iframe title="Signup for our newsletter (Substack)" src="https://justfixitinpost.substack.com/embed" width="480" height="280" style={{
          background: 'var(--clr-text-bright)'
        }} frameBorder="0" scrolling="no"></iframe>
				</StyledNewsletter>
			</div>
		</StyledLandingSection>;
};

require("./LandingSignup.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingSignup.tsx");